import React, { Component } from 'react';
import _ from 'lodash';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import InfoBlockTampa from './InfoBlockTampa'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import timelineIcon from '../../../../public/img/tampa/ui/icon-timelineBullet.png'
import StoryTampa from './StoryTampa';
import BackButtonTampa from './BackButtonTampa';
import { dp } from '../../../utils/shared.js';
// import BRSpan from '../../General/BRSpan'

var spacialEvents;
const config = {
	events_on_screen: 10,
	line_thickness: 0.02,
}

class TimelineTampa extends Component {

	constructor(props) {
		super(props);
		this.refDict = {};
		// this.cycleDate = this.cycleDate.bind(this);
		// this.onScrollEnd = this.onScrollEnd.bind(this);
		this.state = {
			spacialEvents: null,
			sideMargin: null,
			totalHeight: null,
			currentEvent: 0,
			showStoryModal: false,
			initializedRefs: false,
			contentIndex: 0
		}
		this._subscribeModule = null;
		this._buttonBinded = false;
		this._baseInset = this.props.screen.screenWidth * .5;
		this._eventIndex = 0;
		this._rowWrapperRef = null;
		this._titleStyle = {
			position: 'absolute',
			fontFamily: 'aleo-bolditalic', fontSize: this.props.screen.r16_9.p10,
			left: this.props.screen.r16_9.width * .05,
		}
		this._titleHorizontalRule = {
			width: '90%',
			height: this.props.screen.r16_9.p10 * 0.15,
			backgroundColor: '#223954',
			display: 'inline-block',
			position: 'absolute',
			top: this.props.screen.r16_9.p10 * 1.25,
			left: 0,
			marginLeft: this.props.screen.r16_9.width * .05,
		}
		this._bottomNavOffset = 0;
		if (this.props.content.settings.custom_vars && this.props.content.settings.custom_vars.bottomnav === "true") {
			this._bottomNavOffset = this.props.screen.r16_9.p10;
		}
    this.timelineRefs = [];
    this._mainMenuBackground = this.getMainMenuBackground();
	}

	componentWillUnmount() {
		for (let a = 0; a < this.timelineRefs.length; a++) {
			if (this.timelineRefs[a].el) {
				this.timelineRefs[a].el.removeEventListener("tap", () => this.handleEventSelection(this.timelineRefs[a].data));
			}
		}
	}

	componentDidMount() {
		let totalHeight = (this.props.module.children.length + 1) * (this.props.screen.sv.height / config.events_on_screen);
		this.getRelativeLocations(this.props.module.children, totalHeight, 0);
  }
  
  getMainMenuBackground = () => {
    let menuFolder = this.props.content.story_categories.find(folder => {
      let folderType = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      if (folderType !== null) {
        return folder.parent_category === Number(this.props.content.settings.selected_root_folder) && folderType === "menu"
      }

      return false;
    });
    let backgroundObj = _.get(menuFolder.contents, 'images[0]', null);
    return dp(this.props.screen, backgroundObj);
  }

	initializeTimelineRefs = () => {
		if (this.state.initializedRefs === false) {
			for (let a = 0; a < this.timelineRefs.length; a++) {
				this.timelineRefs[a].el.addEventListener("tap", () => this.handleEventSelection(this.timelineRefs[a].data.folder_module_id));
			}
			this.setState({
				initializedRefs: true
			});
		}
	}

	handleBack = () => {
		this.setState({
			showStoryModal: false
		})
	}

	getRelativeLocations(events, totalHeight, topMargin) {
		spacialEvents = [];
    let spacing = _.get(this.props.module, 'contents.custom_fields.event_spacing.val.value', "even");
		const sortedEvents = events.sort((a, b) => {
			const aDate = new Date(_.get(a, 'contents.sorting_date', 0));
			const bDate = new Date(_.get(b, 'contents.sorting_date', 0));
			return aDate.getTime() - bDate.getTime();
		});
		if (spacing === "even") {
			let eventInc = this.props.screen.sv.height / config.events_on_screen;
			_.forEach(sortedEvents, (event, index) => {
				let raw = eventInc * index;
        let span = raw + eventInc;
				// let date = _.get(event, 'contents.sorting_date', "2000-01-01");
				let date = _.get(event, 'contents.headline', "2000-01-01");
        spacialEvents.push({ 
          header: event.name,
          date: date,
          offset: span, 
          raw: raw, 
          text: "Event Text",
          images: event.contents.images,
          story: event });
			});
			this.setState({
				spacialEvents: spacialEvents,
				totalHeight: totalHeight
			})
		} else { //relative spacing
			let fullTimeSpan = events[events.length - 1].date - events[0].date;
			_.forEach(sortedEvents, (event) => {
				let date = _.get(event, 'contents.headline', "2000-01-01");
				let raw = (((event.date - events[0].date) / fullTimeSpan) * totalHeight)
				let span = raw + topMargin;
				spacialEvents.push({ 
          header: event.name,
          date: date,
          offset: span, 
          raw: raw, 
          text: "Event Text", 
          images: event.images, 
          story: "Event Story" })
			});
			this.setState({
				spacialEvents: spacialEvents,
				totalHeight: totalHeight
			})
		}
	}

	parseDate = (date) => {
		let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
			"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
		];
		let monthName = monthNames[date.getMonth()]
		// let monthNumber = String(date.getMonth() + 1);
		let fullYear = String(date.getFullYear());
		// let shortYear = fullYear.substring(2);
		let day = String(date.getDate());
		let unit = this.props.screen.r9_16.p10
		return (<span>
			<b>
				<div style={{ textAlign:"right", fontSize: unit * .2, maxWidth: this.props.screen.screenWidth * .11574074074074074074 }}>{monthName} {day}</div>
				<br />
				<div style={{ textAlign:"right", fontSize: unit * .35, maxWidth: this.props.screen.screenWidth * .11574074074074074074 }}>{fullYear}</div>
			</b>
		</span>);
	}

	cycleDate(mode, index) {
		let tempCurrentEvent = this.state.currentEvent;
		if (mode === 0) { //backward
			tempCurrentEvent--;
			if (tempCurrentEvent < 0) {
				tempCurrentEvent = spacialEvents.length - 1;
			}
		}
		else if (mode === 1) { //forward
			tempCurrentEvent++;
			if (tempCurrentEvent > spacialEvents.length - 1) {
				tempCurrentEvent = 0;
			}
		}
		else { //to specific index
			tempCurrentEvent = index;
		}
		this.refDict[0].withIScroll(function (iScroll) {
			iScroll.scrollTo(-(spacialEvents[tempCurrentEvent].raw), 0, 1000);
		})
		this.setState({
			currentEvent: tempCurrentEvent
		})
	}

	onScrollEnd = () => {
		var evt = new MouseEvent('mousedown', {
			bubbles: true,
			cancelable: false,
			view: window
		});
		window.dispatchEvent(evt);
	}

	renderSpacialEvents() {
		let circleRadius = this.props.screen.r16_9.p10 * 0.15
		if (this.state.spacialEvents.length === 0) {
			return (
				<span />
			)
		}

		const unit = this.props.screen.r9_16.p10
		const infoBlockWidth = unit * 3.35 * .8;
		const insetAmount = unit * 1.55;
		const leftInset = -insetAmount - infoBlockWidth * .95;
		const rightInset = insetAmount;
		const imageHeight = unit * 2 * .8;
		const infoHeight = unit * .85 * .8;
		const fullHeight = imageHeight + infoHeight
		const iconWidth = unit * .25;

		return (
			this.state.spacialEvents.map(function (row, i) {
				//assume left
				let inset = leftInset;
				let dateInset = -insetAmount / 6 - unit;
				// let horizontalLineInset = -insetAmount + this._baseInset;

				let splittedStr = [];
				let date = "";
				if (row.date.includes('<BR>')) {
					splittedStr = row.date.split("<BR>");
					date = splittedStr.map((date, j) => {
						if (i % 2 !== 0) {
							return (<div style={{ textAlign:"right", width: this.props.screen.screenWidth * .10416666666666666667 }} key={j}>{date}</div>);
						} else {
							return (<div style={{ textAlign:"left", width: this.props.screen.screenWidth * .10416666666666666667 }} key={j}>{date}</div>);
						}
					});
				} else if (row.date.includes('<br>')) {
					splittedStr = row.date.split("<br>");
					date = splittedStr.map((date, j) => {
						if (i % 2 !== 0) {
							return (<div style={{ textAlign:"right", width: this.props.screen.screenWidth * .10416666666666666667 }} key={j}>{date}</div>);
						} else {
							return (<div style={{ textAlign:"left", width: this.props.screen.screenWidth * .10416666666666666667 }} key={j}>{date}</div>);
						}
					});
				} else {
					if (i % 2 !== 0) {
						date = (<div style={{ textAlign:"right", width: this.props.screen.screenWidth * .10416666666666666667 }}>{row.date}</div>);
					} else {
						date = (<div style={{ textAlign:"left", width: this.props.screen.screenWidth * .10416666666666666667 }}>{row.date}</div>);
					}
				}

				//offset for right scenario
				if (i % 2 === 0) {
					inset = rightInset
					// horizontalLineInset = this._baseInset + unit * 1.1
					dateInset = insetAmount / 6
        }
        
				return (
					<div key={i} style={{ position: 'absolute', top: row.offset, zIndex: 0 }}>
						{/* horizontal lines */}
						{/* <div style={{
							position: 'absolute',
							backgroundColor: 'white',
							top: circleRadius / 2,
							left: horizontalLineInset,
							width: unit * .55,
							height: unit * config.line_thickness
						}}>
						</div> */}
						{/* <span style={{ ...circle }} /> */}
						<div style={{ position: 'absolute', left: this._baseInset - iconWidth / 2 }}>
							<img alt="timelineicon" style={{ width: iconWidth, height: iconWidth }} src={timelineIcon} />
						</div>
						<span className="crimson-regular" style={{ color: '#143e77', fontSize: unit * .35, position: 'absolute', left: dateInset + this._baseInset, width: unit * 5, top: -unit * .275 }}>
							<b>
								{/* <BRSpan str={row.date} /> */}								
								{date}
							</b>
						</span>

						<span ref={el => this.timelineRefs[i] = { el: el, data: row.story }} style={{ position: 'absolute', left: (inset) + this._baseInset, top: (-fullHeight / 2) + ((circleRadius / 2)) }}>
							<InfoBlockTampa
								imgsrc={dp(this.props.screen, _.get(row, 'images[0]', null), { path: '/img/ui/', file_name: 'image_default.png' })}
								imageHeight={imageHeight}
								infoHeight={infoHeight}
								width={infoBlockWidth}
								unit={unit * .8}
								text={row.header}
								infoColor={"#143e77"}
								infoBackgroundColor={'white'}
								fontFamily={'opensans-regular'}
								fontSize={unit * 0.15}
							/>
						</span>
					</div>
				);
			}, this)
		)
	}

	handleEventSelection = (story_id) => {
    let story = this.props.module.children.find(st => st.folder_module_id === Number(story_id));
    if (story) {
      this.setState({
        showStoryModal: true,
        story: story
      });
    }
	}

	cycleStory = (direction) => {
		if (direction === "forward") {
			this._eventIndex += 1;
			if (this._eventIndex >= this.props.module.children.length) {
				this._eventIndex = 0;
			}
		}
		else {
			this._eventIndex -= 1;
			if (this._eventIndex < 0) {
				this._eventIndex = this.props.module.children.length - 1;
			}
		}
		if (!this.props.module.children[this._eventIndex].story || isNaN(Number(this.props.module.children[this._eventIndex].story))) {
			this.cycleStory(direction);
		} else {
      this.handleEventSelection(this.props.module.children[this._eventIndex].story);
		}
	}

	getBackgroundImage = () => {
    let defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' }
    let backgroundObj = _.get(this.props.module, 'contents.images[0]', null);
    return dp(this.props.screen, backgroundObj, defaultImg);
	}

	getIconImage = () => {
    let iconObj = _.get(this.props.module, 'contents.images[2]', null);
    return dp(this.props.screen, iconObj);
	}

	render() {
		const backgroundImage = this.getBackgroundImage();
		const iconImage = this.getIconImage();
		const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;

		const textShadowSize = Math.ceil(this.props.screen.screenHeight * 0.003);
		const textShadow = `${textShadowSize}px ${textShadowSize}px ${textShadowSize}px black`;
		
		if (!this.state.spacialEvents) {
			return <div />
		}

		let spacialEvents = this.renderSpacialEvents();
		//let quickJumps = this.renderQuickJumps();
		const unit = this.props.screen.r9_16.p10
		// let mult = .8
		let scrollableArea = this.props.screen.screenHeight * .72916666666666666667;

		return (
			<div style={{ width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: backgroundSize, backgroundImage: "url(" + backgroundImage + ")" }} >
				<div style={{ textAlign: 'center', position: 'absolute', width:"100%" }}>
					<br /><br />
					<img alt="Timeline" src={iconImage} style={{ display: 'block', margin: 'auto', width: '8vh' }} />

					<div className="crimson-semi-bold" style={{ textShadow: textShadow,fontSize: '4vh' }}>
						{this.props.module.name}
					</div>
					<div className="crimson-regular" style={{ textShadow: textShadow,fontSize: '2vh', paddingRight:"8.333333333vh", paddingLeft:"8.333333333vh", lineHeight: this.props.screen.screenWidth * .03240740740740740741 + "px" }}>
						{_.get(this.props.module, 'description', null)}
					</div>
					<div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
						<div style={{ width: '80vw', height: '15vw', borderRadius: '2vw', padding: '5vw' }}>
							<div style={{ color: 'black', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
							</div>
						</div>
					</div>
				</div>

				{/* <div className="topgradblackP25" style={{ width: '100%', height: unit * .25, marginTop:"-1.5625vh" }} /> */}
				
				<div style={{ position: 'absolute', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height }} />
				<div style={{
					position: 'absolute',
					top: "26.96759259259259259259vh",
					left: 0,
					width: this.props.screen.screenWidth,
					height: scrollableArea,
					touchAction:"none"
				}}>
					<ReactIScroll ref={el => this.refDict[0] = el} iScroll={iScroll}
						onScrollEnd={this.onScrollEnd}
						options={{
							mouseWheel: true,
							scrollbars: false,
							scrollX: false,
							scrollY: true,
							probeType: 2,
							bounce: false,
							momentum: true,
							deceleration: 0.005,
							useTransition: true,
							disableTouch: false,
							disablePointer: false,
							disableMouse: false,
							tap: true
						}}
						onRefresh={this.initializeTimelineRefs}
					>						
						{/* TIMELINE DIV */}
						<div style={{ width: this.props.screen.r16_9.width * .6, height: this.state.totalHeight, minHeight: '100%' }}>
							{/* vertical line */}
							<div style={{
								position: 'absolute',
								top: 0,
								backgroundColor: 'white',
								left: this._baseInset,
								width: this.props.screen.sv.p10 * config.line_thickness,
								height: '100%'
							}} />
							<div style={{
								position: 'absolute',
								width: this.props.screen.r16_9.width,
								height: this._titleHorizontalRule.top
							}}>
								{/* <span style={this._titleHorizontalRule} /> */}
							</div>
							{spacialEvents}
						</div>
					</ReactIScroll>
					{/* <div className="bottomgradblackP25" style={{ position: 'absolute', width: '100%', height: unit * .25, bottom: 0 }} /> */}
					<div className="topgradblackP25" style={{ position: 'absolute', width: '100%', height: unit * .25, bottom: '71.5vh' }} />
				</div>

				<div style={{ position: 'absolute' }}>
					{/* MODAL CODE */}
					<CSSTransitionGroup
						component='div'
						className="containerFade"
						style={{ minHeight: '100%' }}
						transitionName='example'
						transitionEnterTimeout={0}
						transitionLeaveTimeout={0}>
						<div key={this.state.showStoryModal} style={{ position: 'absolute' }}>
							{this.state.showStoryModal ? 
                <StoryTampa 
                  backgroundImage={this._mainMenuBackground}
                  showBackground={true}
                  screen={this.props.screen}
                  screensNumber={this.props.screensNumber}
                  story={this.state.story}
                  content={this.props.content}
                  clickAction={this.handleBack}
                  contentIndex={this.state.contentIndex}
                /> : null
              }

							{this.state.showStoryModal ?
								<BackButtonTampa
									unit={this.props.screen.r9_16.p10 / this.props.screensNumber}
									width="3.90625vh"
									height="4.5vh"
									top="56.46875vh"
									border="0.84375vh"
									clickAction={this.handleBack}
									text={'back'}
									mode={this._mode}>
								</BackButtonTampa>
								: null}
						</div>
					</CSSTransitionGroup >
				</div>
			</div>
		)
	}
}

export default TimelineTampa;


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/TimelineTampa.jsx